var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Banner",class:[_vm.variant, _vm.isSlim ? 'isSlim' : '']},[(_vm.icon)?_c('Icon',{attrs:{"name":_vm.icon}}):_vm._e(),_c('div',{staticClass:"body"},[(_vm.title)?_c('strong',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"description"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }